import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import goldcoin from "../../../../assets/icons/coins/gold-coin.png";
import silvercoin from "../../../../assets/icons/coins/silver-coin.png";
import {
  CircleadditionIcon,
  CirclesubtractionIcon,
  SearchIcon,
} from "../../../../assets/icons/svgicons";
import Button from "../../../common/Button/Button";
import Card from "../../../common/Card/Card";
import Cart from "../../../common/Header/Cart/Cart";
import ProductDetails from "../../../common/Modals/ProductDetails/ProductDetails";
import SellWithUs from "../../../common/Modals/SellWithUs/SellWithUs";
import NoContent from "../../../common/NoContent/NoContent";
import {
  addToCartAction,
  fetchProductList,
  setCartUpdateFlag,
} from "../../../../features/marketPlace/marketPlaceSlice";
import MarketPlaceCard from "./MarketPlaceCard/MarketPlaceCard";
import MarketPlaceCardShimmer from "./MarketPlaceCardShimmer/MarketPlaceCardShimmer";
import * as _ from "lodash";
import { useDebounce } from "../../../customHook/useDebeunce";
import Pagination from "../../../common/Pagination/Pagination";
import { saveCartCount } from "../../../../features/persist/persistSlice";
import {
  getPremiumFeeAction,
  getUserWalletBalanceAction,
  getSellWithUsTokenPricesAction,
  createSellWithUsP2POrderAction,
  getTokenBalanceAction,
  getUserCoinListAction,
  getUsersInvestmentAction,
} from "../../../../features/user/userSlice";
import { getCartListAction } from "../../../../features/marketPlace/marketPlaceSlice";
import Commonpagination from "../../../common/Pagination/Commonpagination";
import { spotPlusPremium, formatPrice } from "../../../../utils/utils";
import {
  Messages,
  STATUS_CODE,
  assetOptions,
} from "../../../../utils/constants";
import { FORMIK_REGEX } from "../../../../utils/constants";
import { useFormik } from "formik";
import { validationMessage } from "../../../../Helper/helperfunction";
import * as Yup from "yup";
import SellConfirm from "../../../common/Modals/SellWithUs/SellConfirm/SellConfirm";
import { toFix } from "../../../../utils/utils";
import styles from "./MarketPlace.module.scss";
import CommonBanner from "../../../common/CommonBanner/CommonBanner";
import tradechartIcon from "../../../../assets/icons/tradechartIcon.svg";
import watchcircle from "../../../../assets/icons/watchcircle.svg";
import paichartIcon from "../../../../assets/icons/paichartIcon.svg";
import timewatchcircle from "../../../../assets/icons/timewatchcircle.svg";
import bakingcircle from "../../../../assets/icons/bakingcircle.svg";
import Select from "../../../common/Formik/Select/Select";
import InputFormik from "../../../common/Formik/Input/InputFormik";
import goldCoin from "../../../../assets/icons/coins/goldCoin.svg";
import silverCoin from "../../../../assets/icons/coins/silverCoin.svg";
import goldstbl from "../../../../assets/icons/coins/goldstbl.svg";
import silverstbl from "../../../../assets/icons/coins/silverstbl.svg";
import PriceChartModal from "./PriceChartModal/PriceChartModal";
import SetPriceAlertModal from "./SetPriceAlertModal/SetPriceAlertModal";
import SellModal from "./SellModal/SellModal";
import CalculatorModal from "./CalculatorModal/CalculatorModal";
import { useBanner } from "../../../customHook/useBanner";
import PriceAlertListing from "./PriceAlertListing/PriceAlertListing";

const MarketPlace = () => {
  const cartChangeFlag = useSelector(
    (state) => state.marketPlace.cartUpdateFlag
  );
  const userData = useSelector((state) => state?.persist?.userInfo);
  const spotPremiumPrice = useSelector(
    (state) => state?.users?.spotPremiumPrice
  );
  const spotPrice = useSelector((state) => state?.users?.spotPrice);
  const [buyPrices, setBuyPrices] = useState({});
  const [loading, setLoading] = useState(true);
  const [modalData, setModalData] = useState(null);
  const [search, setSearch] = useState(null);
  const [show, setShow] = useState(false);
  const [showCart, setShowCart] = useState(false);
  const [sellWithUs, setSellWithUs] = useState(false);
  const [productList, setProductList] = useState([]);
  const [imageUrl, setImageUrl] = useState("");
  const debounced = useDebounce(search, 500);
  const [totalPages, setTotalPages] = useState("");
  const pageSize = 12;
  const [page, setPage] = useState(1);
  const [premiumFee, setPremiumFee] = useState({});
  const dispatch = useDispatch();
  const [sellModal, setSellModal] = useState(false);
  const [tokenPrices, setTokenPrices] = useState([]);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [selectedTokenPrice, setSelectedTokenPrice] = useState(null);
  const [quantity, setQuantity] = useState("");
  const [updatedAssetOptions, setUpdatedAssetOptions] = useState(assetOptions);
  const [coinList, setCoinList] = useState([]);
  const [showPrice, setShowPrice] = useState();
  const [showPricealert, setShowPricealert] = useState();
  const [priceAlertListModal, setPriceAlertListMoadal] = useState();
  const [quantityOrder, setQuantityOrder] = useState(false);
  const [priceOrder, setPriceOrder] = useState(false);
  const [averageOrder, setAverageOrder] = useState(false);
  const [investmentList, setInvestmentList] = useState([]);
  const [showCalculator, setShowCalculator] = useState();

  const tokenBalance = useSelector((state) => state?.users?.tokenBalance);
  const TOKEN_CONFIG = {
    1: {
      name: "Gold STBL",
      shortName: "GSTBL",
      icon: goldCoin,
      largeIcon: goldstbl,
      color: "#F2B807",
      backedBy: "Backed by physical gold reserves",
    },
    2: {
      name: "Silver STBL",
      shortName: "SSTBL",
      icon: silverCoin,
      largeIcon: silverstbl,
      color: "#A8A8A8",
      backedBy: "Backed by physical silver reserves",
    },
  };

  const buyValidationSchema = Yup.object({
    quantity: Yup.string()
      .required(validationMessage("Quantity"))
      .matches(FORMIK_REGEX.DECIMALNUMBERS, Messages?.NUMBERVALIDATION),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      quantity: "",
    },
    validationSchema: buyValidationSchema,
    onSubmit: async (values) => {
      // setShow(true);
    },
  });

  const handleQuantityChange = (event) => {
    const inputQuantity = event.target.value;
    setQuantity(inputQuantity);
  };

  const getBalance = async (data) => {
    try {
      const params = {
        tokenId: selectedAsset?.value,
      };
      await dispatch(getTokenBalanceAction(params));
    } catch (error) {
      console.log("error", error);
    }
  };
  useEffect(() => {
    getBalance();
  }, [selectedAsset]);

  const handleAssetTypeChange = (selected) => {
    setBuyPrices(selected.calculatedBuyPrice);
    setSelectedAsset(selected);
    fetchTokenPrice(selected.value);
  };

  const getUsersInvestment = async (data) => {
    try {
      let params = {};
      if (data === "Qty") {
        params.sortByQuantity = quantityOrder == true ? "ASC" : "DESC";
      }
      if (data === "Average") {
        params.sortByAverage = averageOrder == true ? "ASC" : "DESC";
      }
      if (data === "Price") {
        params.sortByPrice = priceOrder == true ? "ASC" : "DESC";
      }

      const response = await dispatch(getUsersInvestmentAction(params));
      if (response?.status === 200) {
        const userData = response.data.data?.getUserInvestments?.tokenSales;
        // console.log("userData--market", userData, response.data.data);
        // const imageUrlResponse = response?.data?.data?.imageUrl;
        // setImageUrl(imageUrlResponse);
        setInvestmentList(userData);
      }
    } catch (error) {
      console.log("Something went wrong:", error);
    }
  };

  useEffect(() => {
    getUsersInvestment();
  }, []);

  useEffect(() => {
    // console.log("Enriching product list with live prices and investment data...", productList);
    if (productList.length > 0 && spotPrice && investmentList.length > 0) {
      const enrichedList = productList.map((product) => {
        const tokenId = product.token_id;
        const config = TOKEN_CONFIG[tokenId];
        const livePrice =
          tokenId === 1 ? spotPrice.goldPrice : spotPrice.silverPrice;
        const investment = investmentList.find(
          (inv) => inv.token_id === tokenId
        );



        return {
          ...product,
          livePrice: parseFloat(livePrice || 0).toFixed(2),
          change24h: investment?.changePerc
            ? (investment.changePerc).toFixed(2)
            : "0.00",
          tokenConfig: config,
          circulatingSupply: "921,456", // replace with real data later if available
        };
      });
      setProductList(enrichedList);
    }
  }, [spotPrice, investmentList, productList.length]);

  useEffect(() => {
    const calculateBuyPrice = (data) => {
      const spot =
        data.name === "Gold STBL" ? spotPrice.goldPrice : spotPrice.silverPrice;
      if (data.premium_type === "PERCENTAGE") {
        return spot - spot * (data.sell_premium / 100);
      } else {
        return spot - data.sell_premium;
      }
    };

    const newAssetOptions = assetOptions.map((option) => {
      const correspondingToken =
        Array.isArray(tokenPrices) &&
        tokenPrices?.find((token) => token.name === option.label);

      if (correspondingToken) {
        const buyPrice = calculateBuyPrice(correspondingToken);

        return {
          ...option,
          calculatedBuyPrice: buyPrice,
        };
      }
      return option;
    });

    setUpdatedAssetOptions(newAssetOptions);
  }, [tokenPrices, spotPrice, sellModal]);

  const fetchTokenPrice = async (tokenId) => {
    try {
      const response = await dispatch(
        getSellWithUsTokenPricesAction({ tokenId: tokenId })
      );
      if (response.status === 200) {
        const tokenData = response.data.data;
        setTokenPrices(tokenData);
        const priceValue =
          Array.isArray(tokenData) &&
          tokenData?.find((token) => token.token_id === tokenId);
        if (priceValue) {
          setSelectedData(priceValue);
          setSelectedTokenPrice(priceValue.price);
        }
      }
    } catch (error) {
      console.error("Error fetching token prices:", error);
    }
  };

  const sellOrderSubmit = async () => {
    try {
      formik.handleSubmit();
      if (formik.isValid) {
        const dataObj = {
          amount: parseFloat(selectedData?.price),
          quantity: parseFloat(formik?.values?.quantity),
          tokenId: selectedData?.token_id,
          orderType: "SELL",
          price: parseFloat(selectedData?.price),
          tokenName: selectedData?.name,
        };
        const response = await dispatch(
          createSellWithUsP2POrderAction(dataObj)
        );

        if (response.status === 200) {
          console.log("Sell order API response:", response);

          // Partnero Transaction Tracking
          if (window.po && typeof window.po === "function") {
           
            try {
              const partneroData = {
                data: {
                  key: response.data.data.transactionId, // Transaction ID
                  amount: Number(dataObj.amount * dataObj.quantity), // Total amount
                  amount_units: "usd", // Currency code
                  customer: {
                    key: userData?.email, // User identifier
                  },
                },
              };

             

              window.po("transactions", "create", partneroData);

            } catch (error) {
              console.error("Error during Partnero transaction tracking:", {
                error: error.message,
                transactionId: response.data.data.transactionId,
                userEmail: userData?.email,
                totalAmount: Number(dataObj.amount * dataObj.quantity),
              });
            }
          } else {
            console.warn(
              "⚠️ Partnero 'po' function not found on window. Ensure Partnero script is loaded."
            );
          }

          setSellModal(false);
          // handleClose();
        }
      }
    } catch (error) {
      console.error("Error fetching token prices:", error);
    }
  };

  const calculateTotal = () => {
    const totalPrice = Number(quantity) * Number(buyPrices);
    return formatPrice(totalPrice);
  };

  const adminPremiumFee = async () => {
    const res = await dispatch(getPremiumFeeAction());
    if (res?.status === 200) {
      setPremiumFee(res?.data?.data);
    }
  };

  useEffect(() => {
    adminPremiumFee();
    getWalletBalance();
  }, []);

  const getProductList = async (debounced) => {
    const pageNumber = debounced ? 1 : page;
    const response = await dispatch(
      fetchProductList({
        page: pageNumber,
        size: pageSize,
        searchKeyword: debounced,
      })
    );

    if (response?.status === 200) {
      const rows = response?.data?.data?.rows || [];
      const correctImageUrl = response.data.data.imageUrl;

      // console.log("PRODUCT LIST API RESPONSE:", { correctImageUrl, rows });

      // Fix: Attach correct imageBaseUrl to EVERY product
      const enrichedProducts = rows.map((item) => ({
        ...item,
        imageBaseUrl: correctImageUrl, // This is the key
        quantity: 1,
        isNew: false,
      }));

      setImageUrl(correctImageUrl);
      setProductList(enrichedProducts);
      setTotalPages(response?.data?.data?.totalPages);
    }
  };

  const getWalletBalance = async () => {
    try {
      await dispatch(getUserWalletBalanceAction());
    } catch (error) { }
  };

  const handleQtyChange = (
    productId,
    operator,
    value,
    decimal,
    minOrderQty
  ) => {
    // console.log("minOrderQty1111111", minOrderQty);
    const index = productList?.findIndex((o) => o.id == productId);
    if (index < 0) return;

    // If value is string (input in progress), just assign as is (to allow typing decimals)
    if (typeof value === "string") {
      productList[index].quantity = value;
    } else if (value !== undefined) {
      // If number, assign directly
      productList[index].quantity = value;
    }

    if (operator == "+") {
      productList[index].quantity = Number(
        (Number(productList[index].quantity) + Number(minOrderQty)).toFixed(
          decimal
        )
      );
    }
    if (operator == "-" && Number(productList[index].quantity) > minOrderQty) {
      productList[index].quantity = Number(
        (Number(productList[index].quantity) - Number(minOrderQty)).toFixed(
          decimal
        )
      );
    }

    setProductList(JSON.parse(JSON.stringify(productList)));
    setModalData(JSON.parse(JSON.stringify(productList[index])));
  };

  useEffect(() => {
    getProductList();
    dispatch(getCartListAction());
    setTimeout(() => {
      setLoading(false);
    }, 1400);
  }, [page]);

  useEffect(() => {
    if (debounced) {
      getProductList(debounced);
    } else {
      getProductList();
    }
  }, [debounced]);

  useEffect(() => {
    if (cartChangeFlag === true) {
      dispatch(getCartListAction());
      getProductList();
      dispatch(setCartUpdateFlag(false));
    }
  }, [cartChangeFlag]);

  const getRangePrice = (qty, priceChart) => {
    if (!priceChart || priceChart.length === 0) {
      return 0;
    }
    priceChart.forEach((priceRange) => { });
    const matchingPrice =
      Array.isArray(priceChart) &&
      priceChart?.find(
        (priceRange) =>
          qty >= priceRange.min_quantity && qty <= priceRange.max_quantity
      );

    if (matchingPrice) {
      const priceWithFee =
        Number(matchingPrice.stripe_payment_price) +
        Number(matchingPrice.fee_value || 0);
      return priceWithFee;
    }

    return 0;
  };

  // Updated handleAddToCart function in MarketPlace component
  const handleAddToCart = async (item, mode, valueInput) => {
    try {
      const totalPrice = getRangePrice(item.quantity, item.productPrices);
      let price = _.sortBy(item?.productPrices, "min_quantity")[0]
        .stripe_payment_price;
      let dataObj = {
        productId: item.id,
        quantity: item.quantity,
        price: (item?.token_id == 1
          ? spotPremiumPrice?.goldPrice + totalPrice
          : spotPremiumPrice?.silverPrice + totalPrice
        ).toFixed(2),
        tokenId: item.token_id,
        selectionMode: mode === "Order By Qty" ? "QUANTITY" : "VALUE",
        orderValue: valueInput ? valueInput : 0, // Add valueInput when selectionMode is VALUE
      };
      const response = await dispatch(addToCartAction(dataObj));
      if (response.status === 200) {
        dispatch(saveCartCount(1));
        dispatch(getCartListAction());
        getProductList(); // This will refresh the product list
        setShowCart(true);

        // Force refresh cart data in all MarketPlaceCard components
        // by triggering a state update that will cause cart re-fetch
        dispatch(setCartUpdateFlag(true));
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  };

  const getTotalPrice = (item) => {
    let premiumPrice = premiumFee?.filter(
      (elem) => elem.token_id === item.token_id
    )[0];

    let spotPremium = 0;
    if (item?.token_id == 1) {
      spotPremium = spotPlusPremium(
        spotPrice?.goldPrice,
        premiumPrice?.fee_value,
        premiumPrice?.type
      );
      return toFix(Number(item?.quantity * spotPremium), 5);
    } else {
      spotPremium = spotPlusPremium(
        spotPrice?.silverPrice,
        premiumPrice?.fee_value,
        premiumPrice?.type
      );
      return formatPrice(Number(item?.quantity * spotPremium));
    }
  };

  const fetchCoinOptions = async () => {
    try {
      const response = await dispatch(getUserCoinListAction());
      if (response.data.status === STATUS_CODE.successful) {
        const newData = response.data.data.coinList;
        setCoinList(newData);
      }
    } catch (error) {
      console.error("Error fetching coin options:", error);
    }
  };
  const toolscard = [
    { classcard: '', iconcard: tradechartIcon, label: 'Price Charts', values: 'Advanced analytics', onClick: () => setShowPrice(true), },
    {
      classcard: '', iconcard: watchcircle, label: 'Price Alerts', values: 'Never miss a move', onClick: () => setShowPricealert(true),
      onClicklist: () => setPriceAlertListMoadal(true)
    },
    { classcard: '', iconcard: paichartIcon, label: 'Portfolio Calculator', values: 'Plan your investments', onClick: () => setShowCalculator(true), },
  ];
  // const cardmarket = [
  //   {
  //     classcard: "active-week",
  //     iconcard: paichartIcon,
  //     label: "Market Cap",
  //     values: "$2.4B",
  //     activelabel: "+5.2% this week",
  //   },
  //   {
  //     classcard: "light_green",
  //     iconcard: timewatchcircle,
  //     label: "24h Volume",
  //     values: "$45.2M",
  //     activelabel: "Active trading",
  //   },
  //   {
  //     classcard: "light_blue",
  //     iconcard: bakingcircle,
  //     label: "Backing Ratio",
  //     values: "1%",
  //     activelabel: "Fully reserved",
  //   },
  // ];
  const orderoptions = [
    { value: "Checking", label: "Checking" },
    { value: "Savings", label: "Savings" },
  ];


  const { data, loadingBanner } = useBanner("MARKETPLACE");
  const sortedProductList = [...productList].sort(
    (a, b) => a.token_id - b.token_id
  );

  return (
    <>
      <section className={styles.marketplace}>
        {/* <CommonBanner
          className="dashboard_banner"
          title="Gold is the timeless hedge against uncertainty."
          subtitle="John Doe New market"
        // bannerImg={data?.imageUrl + data?.image}
        // loadingBanner={loadingBanner}
        /> */}
        <CommonBanner
          className="dashboard_banner"
          title={
            loadingBanner
              ? "Loading banner..."
              : data?.banner_text ||
              "Gold is the timeless hedge against uncertainty."
          }
          subtitle={data?.banner_title || "John Doe New market"}
        />

        <div className={styles.marketplace_innerSec}>
          <div className={styles.marketplace_innerSec_mainSec}>
            {/* <div className={styles.mainSec_leftside}>
              <ul className={styles.listcard}>
                {cardmarket.map((items, index) => (
                  <li key={index}>
                    <div className={`${styles.cardmarket} ${items.classcard}`}>
                      <div className={styles.icon_track}>
                        <img src={items.iconcard} alt="icons" />
                      </div>
                      <div className={styles.text_sec}>
                        <label>{items.label}</label>
                        <div className={styles.bottomtext_sec}>
                          <h4>{items.values}</h4>
                          <p>{items.activelabel}</p>
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div> */}
            <div className={styles.mainSec_rightside}>
              <Row>
                {/* {cardcoins.map((items, index) => (
                  <Col lg={6} md={6} xs={12} key={index}>
                    <div
                      className={`${styles.marketcard} ${
                        items.className || ""
                      }`}
                    >
                      <div className={styles.header}>
                        <div className={styles.headerleft}>
                          <div className={styles.headerleft_imgsec}>
                            <img src={items.tokenIcon} alt="token-icon" />
                          </div>
                          <div className={styles.headerleft_textsec}>
                            <h4>{items.tokentitle}</h4>
                            <h6>{items.tokensubInfo}</h6>
                          </div>
                        </div>
                        <div className={styles.headerright}>
                          <img src={items.tokenCoin} alt="token-coin" />
                        </div>
                      </div>
                      <div className={styles.card_priceSec}>
                        <div className={styles.card_priceSec_leftsec}>
                          <label>{items.pricelabel}</label>
                          <h4 className="big">{items.pricevalue}</h4>
                        </div>
                        <div className={styles.card_priceSec_rightsec}>
                          <label>{items.changelabel}</label>
                          <h6>{items.changevalue}</h6>
                        </div>
                      </div>
                      <div className={styles.footerinputSec}>
                        <div className={styles.inputrowsec}>
                          <div className="inputRow">
                            <Button
                              className="btnSize"
                              variant="without_bg_border"
                            >
                              <CirclesubtractionIcon />
                            </Button>
                            <InputFormik
                              className='input'
                              placeholder='0'
                            />
                            <Button
                              className="btnSize"
                              variant="without_bg_border"
                            >
                              <CircleadditionIcon />
                            </Button>
                          </div>
                          <div className="inner_select">
                            <Select
                              variant="small_height"
                              className="select_time"
                              options={orderoptions}
                              isSearchable={false}
                            />
                          </div>
                        </div>
                        <div className={styles.supply}>
                          <label>{items.supplylabel}</label>
                          <h6>{items.supplyicons}</h6>
                        </div>
                      </div>
                      <div className={styles.btnRow}>
                        <Button
                          fluid
                          className="btnSize"
                          variant="green_btn"
                          onClick={() => setShowCart(true)}
                        >
                          Buy GSTBL
                        </Button>
                        <Button
                          fluid
                          className="btnSize"
                          variant="danger_filled"
                          onClick={() => {
                            fetchCoinOptions();
                            setSellModal(true);
                            getBalance();
                          }}
                        >
                          Sell GSTBL
                        </Button>
                      </div>
                    </div>
                  </Col>
                ))} */}
                {sortedProductList?.map((item) => {
                  const baseUrl = item.imageBaseUrl || "";
                  const firstImage = item.productImages?.[0]?.image;

                  // DEBUG: See exactly what URL is being used
                  // console.log("Product Image Debug:", {
                  //   item: item,
                  //   id: item.id,
                  //   title: item.title,
                  //   hasImages: !!item.productImages?.length,
                  //   firstImageName: firstImage,
                  //   baseUrl,
                  //   finalImageUrl: firstImage
                  //     ? `${baseUrl}${firstImage}`
                  //     : "Using fallback coin",
                  // });

                  const productImageUrl =
                    baseUrl && firstImage
                      ? `${baseUrl}${firstImage}`
                      : item.token_id === 1
                        ? goldstbl
                        : silverstbl;

                  // const productImageUrl = firstImage
                  //   ? `${baseUrl}${firstImage}`
                  //   : item.token_id === 1
                  //   ? goldstbl
                  //   : silverstbl;

                  return (
                    <Col
                      lg={6}
                      md={6}
                      xs={12}
                      key={item.id}
                      className="card_market"
                    >
                      <MarketPlaceCard
                        handleAddtoCart={(mode, valueInput) =>
                          handleAddToCart(item, mode, valueInput)
                        }
                        handleViewDetails={() => {
                          setShow(true);
                          setModalData(item);
                        }}
                        data={item}
                        imageUrl={baseUrl}
                        handleIncDec={handleQtyChange}
                        handleGotoCart={() => setShowCart(true)}
                        premiumFee={premiumFee}
                        tokenIcon={item?.tokenConfig?.icon}
                        largeTokenIcon={productImageUrl} // This will now show real images
                        tokentitle={item?.title || item?.tokenConfig?.name}
                        tokensubInfo={
                          item?.description?.slice(0, 80) + "..." ||
                          item?.tokenConfig?.backedBy
                        }
                        pricelabel="Current Price"
                        pricevalue={`$${item.livePrice || "0.00"}`}
                        changelabel="24h Change"
                        // changevalue={
                        //   item.change24h >= 0
                        //     ? `+${item.change24h}%`
                        //     : `${item.change24h}%`
                        // }
                        changevalue={
                          Number.isFinite(Number(item.change24h))
                            ? item.change24h >= 0
                              ? `+${item.change24h}%`
                              : `${item.change24h}%`
                            : "0.00%"
                        }
                        changeIsPositive={Number(item.change24h) >= 0}
                        // changeIsPositive={item.change24h >= 0}
                        onClicksell={() => {
                          fetchTokenPrice(item.token_id);
                          fetchCoinOptions();
                          setSellModal(true);
                          const initialAsset = assetOptions.find(
                            (opt) => opt.value === Number(item?.token_id)
                          );
                          setSelectedAsset(
                            initialAsset || {
                              value: Number(item?.token_id),
                              label: item?.tokenConfig?.name,
                            }
                          );
                          getBalance();
                        }}
                      />
                    </Col>
                  );
                })}
              </Row>
            </div>
          </div>
          <div className={styles.marketplace_innerSec_footerTools}>
            <h4>Trading Tools</h4>
            <Row>
              {toolscard.map((items, index) => (
                <Col
                  lg={4}
                  md={6}
                  sm={6}
                  xs={12}
                  key={index}
                  className="card_col"
                >
                  <div
                    className={`${styles.cardtools} ${items.classcard}`}
                    onClick={items.onClick}
                  >
                    <div className={styles.icon_track}>
                      <img src={items.iconcard} alt="icons" />
                    </div>
                    <div className={styles.rightSide}>
                      <div className={styles.text_sec}>
                        <label>{items.label}</label>
                        <h4>{items.values}</h4>
                      </div>
                      {items.onClicklist && (
                        <div className={styles.btntools}>
                          <Button
                            fluid
                            className={styles.list_btn}
                            variant="xtra_small"
                            onClick={(e) => {
                              e.stopPropagation();
                              items.onClicklist();
                            }}
                          >
                            Listing
                          </Button>
                        </div>
                      )}
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </div>
      </section>
      {/* <Card
        title="Marketplace"
        className={styles.marketplace}
        headerClassName={styles.header}
        headerContent={
          <>
            <div className={styles.search}>
              <input
                placeholder="Search by Product name..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <span>
                <SearchIcon />
              </span>
            </div>
            <Button
              onClick={() => {
                fetchCoinOptions();
                setSellModal(true);
                getBalance();
              }}
              className={styles.sell_btn}
            >
              Sell To Us
            </Button>
          </>
        }
        bodyClassName={styles.body}
      >
        {loading ? (
          <Row>
            {Array.from({ length: 3 }).map((item, index) => (
              <Col sm={6} lg={4} key={index}>
                <MarketPlaceCardShimmer />
              </Col>
            ))}
          </Row>
        ) : productList?.length > 0 ? (
          <>
            <Row>
              {productList?.map((item) => (
                <Col sm={6} lg={4} key={item.id}>
                  <MarketPlaceCard
                    handleAddtoCart={(mode, valueInput) => handleAddToCart(item, mode, valueInput)}
                    handleViewDetails={() => {
                      setShow(true);
                      setModalData(item);
                    }}
                    data={item}
                    inCart={item.inCart}
                    imageUrl={imageUrl}
                    handleIncDec={handleQtyChange}
                    handleGotoCart={() => setShowCart(true)}
                    premiumFee={premiumFee}
                  />
                </Col>
              ))}
            </Row>
            <Commonpagination
              currentPage={page}
              className={styles.pagination}
              pageSize={pageSize}
              totalPages={totalPages}
              handlePageChange={(selected) => setPage(selected)}
            />
          </>
        ) : (
          <NoContent
            className={styles.no_content}
            content={"No records for your search were found."}
          />
        )}
      </Card>
      <ProductDetails
        show={show}
        data={modalData}
        imageUrl={imageUrl}
        handleIncDec={handleQtyChange}
        handleClose={() => setShow(false)}
        handleGotoCart={() => setShowCart(true)}
        handleAddtoCart={handleAddToCart}
        getTotalPrice={getTotalPrice}
      />
      <Cart show={showCart} handleClose={() => setShowCart(false)} />
      <SellConfirm
        show={sellModal}
        handleClose={() => setSellModal(false)}
        handleSellConfirm={sellOrderSubmit}
        title="Confirm Order"
        tokenPrices={tokenPrices}
        handleAssetTypeChange={handleAssetTypeChange}
        selectedTokenPrice={selectedTokenPrice}
        selectedAsset={selectedAsset}
        handleQuantityChange={handleQuantityChange}
        quantity={formik?.values?.quantity}
        formik={formik}
        calculateTotal={calculateTotal}
        buyPrices={buyPrices}
        setBuyPrices={setBuyPrices}
        updatedAssetOptions={updatedAssetOptions}
        coinList={coinList}
      /> */}
      <PriceChartModal
        show={showPrice}
        handleClose={() => setShowPrice(false)}
      />
      <SetPriceAlertModal
        show={showPricealert}
        handleClose={() => setShowPricealert(false)}
      />
      {priceAlertListModal && (
        <PriceAlertListing
          show={priceAlertListModal}
          handleClose={() => setPriceAlertListMoadal(false)}
        />
      )}
      {/* <SellConfirm
        show={sellModal}
        handleClose={() => setSellModal(false)}
        handleSellConfirm={sellOrderSubmit}
        title="Confirm Order"
        tokenPrices={tokenPrices}
        handleAssetTypeChange={handleAssetTypeChange}
        selectedTokenPrice={selectedTokenPrice}
        selectedAsset={selectedAsset}
        handleQuantityChange={handleQuantityChange}
        quantity={formik?.values?.quantity}
        formik={formik}
        calculateTotal={calculateTotal}
        buyPrices={buyPrices}
        setBuyPrices={setBuyPrices}
        updatedAssetOptions={updatedAssetOptions}
        coinList={coinList}
      /> */}
      <Cart show={showCart} handleClose={() => setShowCart(false)} />
      <SellModal
        show={sellModal}
        handleClose={() => setSellModal(false)}
        handleSellConfirm={sellOrderSubmit}
        tokenPrices={tokenPrices}
        handleAssetTypeChange={handleAssetTypeChange}
        selectedTokenPrice={selectedTokenPrice}
        selectedAsset={selectedAsset}
        handleQuantityChange={handleQuantityChange}
        quantity={formik?.values?.quantity}
        formik={formik}
        calculateTotal={calculateTotal}
        buyPrices={buyPrices}
        setBuyPrices={setBuyPrices}
        updatedAssetOptions={updatedAssetOptions}
        coinList={coinList}
      />

      <CalculatorModal
        show={showCalculator}
        handleClose={() => setShowCalculator(false)}
      />
    </>
  );
};

export default MarketPlace;
